import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsServer() {
  return (
    <div>
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        {/* 서버 - 웹 10만명 ~ */}
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6 '>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>서버</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              웹10만명, 아니 100만명 이상의 동시접속까지 <br className='hidden sm:block' />
              가능하게 할 수 있습니다
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            서버는 다양한 애플리케이션과 소프트웨어를 통해 <br />
            여러 클라이언트 요청을 동시에 처리할 수 있습니다
          </p>
        </div>

        <div className='max-sm:flex max-sm:flex-col-reverse sm:flex items-center justify-center bg-sk-white gap-40 2xs:gap-60 sm:gap-[130px] py-40 sm:pb-40'>
          <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
            다양한 국가와 지역에서 <br />
            레이턴시 없는 서비스 제공합니다
          </p>
          <img src={require('assets/images/skills-server_image1.png')} alt='' />
        </div>

        <div className='items-center justify-center gap-40 py-40 sm:pb-40 max-sm:flex max-sm:flex-col sm:flex bg-sk-white sm:gap-60'>
          <img src={require('assets/images/skills-server_image2.png')} alt='' />
          <div className='flex flex-col items-start gap-24'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              티켓팅, 예약 등 선착순 서비스와 <br />
              온라인 전자결제 및 자동결제 구축해 드립니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              안정적인 선착순 서비스와 신속한 결제 환경을 통해 <br className='hidden 2xs:block' />
              비즈니스 경쟁력을 높여보세요
            </p>
          </div>
        </div>

        <div className='flex flex-col-reverse lg:flex-row sm:flex items-center justify-center bg-sk-white gap-40 2xs:gap-60 sm:gap-120 pt-80 pb-64 sm:pb-120 mb-[-220px] sm:mb-[-260px]'>
          <div className='flex flex-col items-start gap-24'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              API, IoT 연동 및 최적화까지
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              다양한 시스템과의 API 연동으로 데이터 통합과 실시간 소통을 지원합니다 <br />
              IoT 디바이스 연결을 통해 스마트한 환경을 구축하고 운영 효율성을 극대화합니다 <br />
              또한, 최적화된 연동으로 원활한 데이터 흐름과 시스템 성능을 보장합니다
            </p>
          </div>
          <img src={require('assets/images/skills-server_image3.png')} alt='' />
        </div>
      </div>
      <ContactFloatingButton />
    </div>
  )
}
